import { Skeleton, Table, TableBody, TableContainer } from "@mui/material";
import Scrollbar from "../scrollbar";
import { IHeadLabel, ITableProps } from "../../types/table";
import TableHeadComponent from "./table-head";
import TableNoDataComponent from "./table-no-data";
import TablePaginationCustom from "./table.pagination";

type Props = {
    children: JSX.Element;
    table: ITableProps;
    headLabel: IHeadLabel[];
    totalCount: number;
    loading: boolean;
    removePaginate?: boolean
}

const TableComponent = ({ children, table, headLabel, totalCount, loading, removePaginate }: Props) => {

    return (
        <>
            <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                <Scrollbar>
                    <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
                        <TableHeadComponent
                            headLabel={headLabel}
                        />
                        {
                            !loading &&

                            <TableBody>
                                {children}
                                {
                                    totalCount <= 0 &&
                                    <TableNoDataComponent />
                                }

                            </TableBody>
                        }
                    </Table>
                </Scrollbar>
            </TableContainer>
            {
                loading &&

                <Skeleton
                    variant="rounded"
                    height={table.dense ? 250 : 350}
                    sx={{ m: 1.5 }}
                />
            }
            {
                !removePaginate &&
                <TablePaginationCustom
                    count={totalCount}
                    page={table.page}
                    rowsPerPage={table.pageSize}
                    onPageChange={table.onChangePage}
                    onRowsPerPageChange={table.onChangePageSize}
                    dense={table.dense}
                    onChangeDense={table.onChangeDense}
                />
            }
        </>
    );

}

export default TableComponent;